/*
 * Screen-time calculator.
 *
 * years on the phone = (life expectancy - your age) x daily hours / waking hours
 *
 * The same sum as LifetimeProjection in the app's onboarding, down to the
 * details that matter: the divisor is the hours somebody is awake, not the
 * calendar day, the years left never drop below one, and the answer is a whole
 * number. A tenth of a year is the least defensible digit in the whole
 * calculation and the first thing a reader would pick at.
 */

(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-wake-calc]').forEach(function (root) {
      if (root.dataset.wakeBound) return;
      root.dataset.wakeBound = 'true';

      const screen = root.querySelector('[data-wake-calc-screen]');
      const age = root.querySelector('[data-wake-calc-age]');
      const screenOut = root.querySelector('[data-wake-calc-screen-out]');
      const ageOut = root.querySelector('[data-wake-calc-age-out]');
      const yearsOut = root.querySelector('[data-wake-calc-years]');
      const yearsUnit = root.querySelector('[data-wake-calc-years-unit]');
      if (!screen || !age || !yearsOut) return;

      const life = parseFloat(root.dataset.lifeExpectancy) || 80;
      const wakingHours = parseFloat(root.dataset.wakingHours) || 16;
      const units = {
        year: root.dataset.unitYear || 'år',
        years: root.dataset.unitYears || 'år',
        hour: root.dataset.unitHour || 'time',
        hours: root.dataset.unitHours || 'timer',
        minutes: root.dataset.unitMinutes || 'min',
      };
      const ageMaxSuffix = root.dataset.ageMaxSuffix || '';

      /* Follows the storefront's language, so the decimal separator is a comma
         in Danish and a point in English without any branching here. */
      const locale = document.documentElement.lang || 'da';
      const wholeYears = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 });

      function fill(input) {
        const min = parseFloat(input.min);
        const max = parseFloat(input.max);
        const percent = ((parseFloat(input.value) - min) / (max - min)) * 100;
        input.style.setProperty('--wake-fill', percent + '%');
      }

      function formatHours(value) {
        const whole = Math.floor(value);
        const minutes = Math.round((value - whole) * 60);
        const noun = whole === 1 ? units.hour : units.hours;
        if (!minutes) return whole + ' ' + noun;
        return whole + ' ' + noun + ' ' + minutes + ' ' + units.minutes;
      }

      function update() {
        const hours = parseFloat(screen.value);
        const years = parseFloat(age.value);
        const remaining = Math.max(1, life - years);
        /* Never zero, for the same reason the years left are floored at one:
           past the life expectancy the sum stops meaning anything, and a bold
           nought reads as the calculator being broken. */
        const onPhone = Math.max(1, Math.round((remaining * hours) / wakingHours));

        yearsOut.textContent = wholeYears.format(onPhone);
        if (yearsUnit) {
          yearsUnit.textContent = onPhone === 1 ? units.year : units.years;
        }
        if (screenOut) screenOut.textContent = formatHours(hours);
        if (ageOut) {
          /* The top of the slider is open-ended — 100 stands for 100 or more. */
          const suffix = years >= parseFloat(age.max) ? ageMaxSuffix : '';
          ageOut.textContent = years + suffix + ' ' + units.years;
        }

        fill(screen);
        fill(age);
      }

      screen.addEventListener('input', update);
      age.addEventListener('input', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
